import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Header from '../sections/Header';
import HowItWorks from '../sections/HowItWorks';
import MoreAboutTempoAndBenefits from '../sections/MoreAboutTempoAndBenefits';
import { Banners } from '../sections/ActionCards';
import Carousel from '../sections/Carousel';
import { navRoutes } from '../constants';
import WhyJoin from '../sections/WhyJoin';
import { GeneralCardsSection } from '../sections/Cards';
import { StoriesSection } from '../sections/CardsSections';
import placeholderData from '../utils/placeholderData';

export const MembersLandingTemplate = ({
  headerTitle = 'header title...',
  headerDescription = 'header description...',
  testimonials = [],
  partnersSectionTitle = 'Partners section title...',
  partners = [],
  moreAboutTempoTitle = 'More About Tempo Title...',
  moreAboutTempoDescription = 'More About Tempo Description...',
  preview,
  storiesSectionTitle,
}) => {
  const testimonials1 = testimonials.map(testimonial =>
    testimonial ? testimonial.testimonialItem : {},
  );
  const partners1 = partners.map(partner => (partner ? partner.partnerCard : {}));
  return (
    <>
      <Header page="memberHome" title={headerTitle} subtitle={headerDescription} />
      <HowItWorks page="memberHome" title="How does it work?" />
      <WhyJoin />
      <Banners type="member1" />
      <GeneralCardsSection data={partners1} type="spendPostsGlobal" title={partnersSectionTitle} />
      <Carousel data={testimonials1} />
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="spendPostsGlobal"
          title={storiesSectionTitle}
        />
      ) : (
        <StoriesSection title={storiesSectionTitle} />
      )}
      <MoreAboutTempoAndBenefits
        title={moreAboutTempoTitle}
        description={moreAboutTempoDescription}
        to={navRoutes.aboutUs}
      />
      <Banners type="member2" />
    </>
  );
};

const MembersLandingPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  return (
    <Layout>
      <MembersLandingTemplate {...frontmatter} />
    </Layout>
  );
};

export const MembersQuery = graphql`
  query MembersQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        headerTitle
        headerDescription
        partnersSectionTitle
        partners {
          partnerCard {
            title
            description
            imageInfo {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        testimonials {
          testimonialItem {
            content
            author
            location
          }
        }
        moreAboutTempoTitle
        moreAboutTempoDescription
        storiesSectionTitle
      }
    }
  }
`;

export default MembersLandingPage;
